import { Alert } from '@mui/material';
import { memo, useCallback, useEffect, useRef } from 'react';
import { InView } from 'react-intersection-observer';
import { lang } from 'src/utils';

import { Progress } from '../progress/Progress';
import { CardGridContainer, InViewContainer } from './Card.styled';
import { CardGridProps } from './CardGrid.interface';

export const CardGrid = memo(
  ({ children, isLoading, error, updatePage }: CardGridProps) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      if (containerRef.current && updatePage) {
        const { clientHeight } = containerRef.current;
        if (clientHeight < window.innerHeight) {
          updatePage();
        }
      }
    }, [children, updatePage]);
    const onChangeView = useCallback(
      (inView: boolean) => {
        if (inView && updatePage) {
          updatePage();
        }
      },
      [updatePage],
    );

    if (isLoading) {
      return <Progress />;
    }

    if (error) {
      return <Alert severity="error">{lang.alertError}</Alert>;
    }

    return (
      <>
        <CardGridContainer
          ref={containerRef}
          container
          alignItems="stretch"
          spacing={2}>
          {children}
        </CardGridContainer>
        <InView onChange={onChangeView}>
          {({ ref }) => <InViewContainer ref={ref} />}
        </InView>
      </>
    );
  },
);
